export default Object.freeze({
    USER_USERID_MAX_LEN: 6, //ユーザーID 最大桁数
    USER_LASTNAME_MAX_LEN: 8, //姓　最大桁数
    USER_LASTNAME_KANA_MAX_LEN: 15, //セイ　最大桁数
    USER_FIRSTNAME_MAX_LEN: 8, //名　最大桁数
    USER_FIRSTNAME_KANA_MAX_LEN: 15, //メイ　最大桁数
    USER_EMAIL_MAX_LEN: 256, //メールアドレス 最大桁数
    USER_NATIONALITY_MAX_LEN: 30, //国籍 最大桁数
    USER_NEAREST_MAX_LEN: 17, //最寄り駅 最大桁数
    USER_GRADUATE_YEAR_MIN_VAL: 1900, //卒業年度 最小値
    USER_GRADUATE_YEAR_MAX_VAL: 2100, //卒業年度 最大値
    USER_YEARS_EXPERIENCE_MIN_VAL: 0, //IT業界経験年数 最小値
    USER_YEARS_EXPERIENCE_MAX_VAL: 99, //IT業界経験年数 最大値
    RETIREMENT_CODE: 99, //就業状態 退職済選択値
  });